import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";
import withModal from "../withModal";
import { getAuditRecsAsync, getLisTributeTypeAsync, updateAssocIdentBatchAsync } from "../../../actions/makeAWish";
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";
import MaterialModal from "../MaterialModal";
import { IAppState } from "../../../types/stores";
import { Donor, TributeType } from "../../../types/stores/makeAWish";

type ModalProps = {
    tributeData: Donor;
    onSave: () => void;
    BatchNumberD: any;
    seqNumber: string;
};

type Props = {
    isOpen: boolean;
    modalProps: ModalProps;
};

const TributeTypeModal: React.FC<Props> = ({ isOpen, modalProps }: Props) => {
    const { onSave, tributeData, BatchNumberD, seqNumber } = modalProps;
    const dispatch = useDispatch();

    const [tributeType, setTributeType] = useState<string>("");
    const tributeTypes = useSelector<IAppState, Array<TributeType>>(state => state.makeAWish.tributeTypes);

    useEffect(() => {
        if (isOpen) {
            dispatch(getLisTributeTypeAsync());
        }
    }, [dispatch, isOpen]);

    const onListChange = newType => setTributeType(newType);

    const hide = () => {
        dispatch(hideModal("UPDATE_TRIBUTE"));
    };

    const save = () => {
        dispatch(updateAssocIdentBatchAsync(BatchNumberD, seqNumber, tributeData.Id || "", tributeType || ""));
        dispatch(hideModal("UPDATE_TRIBUTE"));
        setTimeout(() => {
            dispatch(getAuditRecsAsync(BatchNumberD));
        }, 800);
        onSave();
    };

    return (
        <MaterialModal
            id={"tribute-type-modal"}
            isOpen={isOpen}
            onClose={() => hide()}
            title={"Tribute Type"}
            maxWidth="xl"
            fullWidth={false}
            onPrimaryButtonRequest={() => save()}
            showPrimaryButton
            primaryButtonText="Save"
            cancelButtonText="Cancel"
        >
            <FormControl fullWidth>
                <InputLabel htmlFor={`tributeType`}>Select Tribute Type</InputLabel>
                <Select
                    id={`TRIBUTETYPE`}
                    onChange={e => {
                        onListChange(e.target.value as string);
                    }}
                    value={tributeType}
                >
                    <MenuItem key={"none"} value={""}>
                        {"None"}
                    </MenuItem>
                    {tributeTypes.map(option => (
                        <MenuItem key={option.Type} value={option.Type}>
                            {option.Combined}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <TextField
                id="NAME"
                label="Name"
                type="text"
                value={tributeData && tributeData.FirstName ? tributeData.FirstName : ""}
                disabled
                fullWidth
            />
            <TextField
                id="COMPANY"
                label="Company"
                type="text"
                value={tributeData && tributeData.Company ? tributeData.Company : ""}
                disabled
                fullWidth
            />
            <TextField
                id="IDENTNUMBER"
                label="Ident Number"
                type="text"
                value={tributeData && tributeData.Id ? tributeData.Id : ""}
                disabled
                fullWidth
            />
        </MaterialModal>
    );
};

export default withModal(TributeTypeModal, "UPDATE_TRIBUTE");
